import $ from 'jquery';
import PxsMap from 'pxs-map';
import IntersectionObserver from 'intersection-observer/intersection-observer';
import Rimg from 'rimg';
import RimgShopify from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';
import ShopifySectionsManager from 'shopify-sections-manager';

import ImagesWithText from './components/ImagesWithText';
import DynamicProduct from './sections/DynamicProduct';
import DynamicInstagram from './sections/DynamicInstagram';
import DynamicTwitter from './sections/DynamicTwitter';

import ThemeUtils from './utils/ThemeUtils';
import Accordion from './utils/Accordion';
import StaticHeader from './sections/StaticHeader';
import StaticCollection from './sections/StaticCollection';
import Contact from './templates/Contact';
import StaticCart from './sections/StaticCart';
import StaticBlog from './sections/StaticBlog';
import Account from './templates/Account';
import RTE from './components/RTE';
import Currency from './utils/Currency';
import GiftCard from './templates/GiftCard';
import StaticSlideshow from './sections/StaticSlideshow';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import PxsVideo from './sections/pxs-video.es';

export default class Startup {
  constructor() {
    const body = $(document.body);

    // Set up conditionals
    this.isHome = body.hasClass('template-index');
    this.isAccount = body.attr('class').indexOf('-customers-') > 0;
    this.currencySettings = document.querySelector('[data-currency-data]') && JSON.parse(document.querySelector('[data-currency-data]').textContent);

    this.isCollection = $('[data-section-type="static-collection"]').length;
    this.isProduct = $('[data-section-type="dynamic-product"]').length;
    this.isProductSlideshow = $('[data-section-type="static-product-slideshow"]').length;
    this.isCart = $('[data-section-type="static-cart"]').length;
    this.isContactPage = $('[data-section-type="static-contact"]').length;
    this.isFAQPage = $('[data-section-type="static-faq"]').length;
    this.isGiftCardPage = $('[data-section-type="static-giftcard"]').length;
    this.isBlog = $('[data-section-type="static-blog"]').length || $('[data-section-type="static-article"]').length;
    this.is404 = $('[data-section-type="static-404"]').length;

    // Common views
    this.sections = new ShopifySectionsManager();
    this.sections.register('static-header', section => new StaticHeader(section));
    this.sections.register('pxs-map', section => new PxsMap(section));
    this.sections.register('pxs-video', section => new PxsVideo(section));
    this.sections.register('static-slideshow', section => new StaticSlideshow(section));

    RimgShopify.init();

    // Conditional views
    if (this.isHome) {
      this.sections.register('dynamic-featured-product', section => new DynamicProduct(section));
      this.sections.register('dynamic-instagram', section => new DynamicInstagram(section));
      this.sections.register('dynamic-twitter', section => new DynamicTwitter(section));
      this.sections.register('dynamic-image-with-text', section => new ImagesWithText(section));
      this.sections.register('dynamic-image-with-text-overlay', section => new ImagesWithText(section));
    }

    if (this.isCollection) {
      this.sections.register('static-collection', section => new StaticCollection(section));
    }

    if (this.isGiftCardPage) {
      this.sections.register('static-giftcard', section => new GiftCard(section));
    }

    if (this.isContactPage) {
      this.sections.register('static-contact', section => new Contact(section));
    }

    if (this.isFAQPage) {
      this.sections.register('static-faq', section => new Accordion(section));
    }

    if (this.isProduct || this.isProductSlideshow) {
      this.sections.register('dynamic-product', section => new DynamicProduct(section));
      this.sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
    }

    if (this.isCart) {
      this.sections.register('static-cart', section => new StaticCart(section));
    }

    if (this.isBlog) {
      this.sections.register('static-blog', section => new StaticBlog(section));
    }

    if (this.isAccount) {
      this.Account = new Account({ el: this.$el });
    }

    if (this.currencySettings && this.currencySettings.enable) {
      const switcherSelector = '[data-currency-converter]';

      CurrencyConverter.init({
        switcherSelector: switcherSelector,
        priceSelector: '.money',
        shopCurrency: this.currencySettings.shopCurrency,
        defaultCurrency: this.currencySettings.defaultCurrency,
        displayFormat: this.currencySettings.displayFormat,
        moneyFormat: this.currencySettings.moneyFormat,
        moneyFormatNoCurrency: this.currencySettings.moneyFormatNoCurrency,
        moneyFormatCurrency: this.currencySettings.moneyFormatCurrency,
      });

      $('.selected-currency', this.$el).text($(switcherSelector).val());
      this.currencyView = new Currency();
    }

    this.rtes = [];
    this.richTextInit();
    ThemeUtils.externalLinks($(document));

    $(document).on('shopify:section:load', (event) => {
      ThemeUtils.externalLinks($(event.target));
      this.richTextInit();
    });

    this.classHoist();

    $(document)
      .on('shopify:section:select.home-page', () => this.classHoist())
      .on('shopify:section:load.home-page', () => this.classHoist())
      .on('shopify:section:deselect.home-page', () => this.classHoist());
  }

  getStyle($el) {
    const styleSetting = $el.attr('class').match(/(default|contrast|accent)-style/);

    if (styleSetting != null) {
      return styleSetting[0];
    }
    return false;
  }

  classHoist() {
    $('.module-container').each((index, section) => {
      const $section = $(section);
      const $parent = $section.parent();

      const sectionStyle = this.getStyle($section);
      const parentStyle = this.getStyle($parent);

      if (!sectionStyle) { return; }

      if (parentStyle) { $parent.removeClass(parentStyle); }
      $parent.addClass(sectionStyle);
    });
  }

  richTextInit() {
    for (let i = 0; i < $('.rte').length; i++) {
      this.rtes.push(new RTE({ el: $('.rte')[i] }));
    }
  }
}

$(() => { window.theme = new Startup(); });
